import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Wie schnell erhalte ich meine Visualisierungen?',
    answer: 'In der Regel liefern wir erste Entwürfe innerhalb von 48 Stunden. Bei größeren Paketen oder komplexen Anforderungen stimmen wir den Zeitplan individuell mit Ihnen ab.'
  }, {
    question: 'Welche Dateien benötigen Sie von mir?',
    answer: 'Wir arbeiten am besten mit Grundrissen (PDF/DWG) und Fotos des aktuellen Zustands. Auch einfache Skizzen oder Moodboards helfen uns, Ihre Vision umzusetzen.'
  }, {
    question: 'Wie sind die Nutzungsrechte geregelt?',
    answer: 'Sie erhalten uneingeschränkte Nutzungsrechte für alle gelieferten Visualisierungen für Print, Web und Social Media.'
  }, {
    question: 'Kann ich mehrere Varianten bestellen?',
    answer: 'Ja, unser System ist darauf ausgelegt, effizient verschiedene Stilrichtungen oder Ausstattungsvarianten zu generieren. Das Varianten-Paket ist dafür ideal.'
  }, {
    question: 'Sind Revisionen im Preis enthalten?',
    answer: 'Ja, je nach Paket sind 1 bis 3 Revisionsrunden inklusive. Weitere Anpassungen berechnen wir fair nach Aufwand.'
  }, {
    question: 'Wie wird mit meinen Daten umgegangen?',
    answer: 'Datenschutz hat höchste Priorität. Ihre Pläne und Fotos werden vertraulich behandelt, sicher gespeichert und nicht ohne Zustimmung für andere Zwecke verwendet.'
  }];
  return <section id="faq" className="py-24 bg-white" data-id="element-57">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <div className="text-center mb-16" data-id="element-59">
          <h2 className="text-3xl sm:text-4xl font-semibold text-black mb-4" data-id="element-60">
            Häufige Fragen
          </h2>
        </div>

        <div className="divide-y divide-neutral-100" data-id="element-61">
          {faqs.map((faq, index) => <div key={index} className="transition-all duration-300" data-id="element-62">
              <button className="w-full px-2 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-63">
                <span className="font-medium text-black" data-id="element-64">{faq.question}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-neutral-400 flex-shrink-0 ml-4" data-id="element-65" /> : <ChevronDown className="w-5 h-5 text-neutral-300 flex-shrink-0 ml-4" data-id="element-66" />}
              </button>

              <div className={`px-2 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 pb-0 opacity-0'}`} data-id="element-67">
                <p className="font-light text-neutral-500 leading-relaxed" data-id="element-68">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}